import React from 'react'
const Aux = (props) =>(
    <div>
       {props.children}
    </div>
)
;

export default Aux;


// WEBPACK FOOTER //
// ./src/hoc/Auxillary/Auxillary.js